import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/schertz")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Schertz, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Schertz & Guadalupe County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Schertz, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Schertz and Guadalupe County.",
      keywords: "awnings Schertz, awning company Schertz, custom awnings Schertz, sail shades Schertz, patio covers Schertz, pergola covers Schertz, metal awnings Schertz, canvas awnings Schertz, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Schertz", "Guadalupe County"),
  }),
  component: () => <CityHomePage city="Schertz" region="Guadalupe County" />,
});
